
import Flickity from "flickity-fade";
import "flickity-imagesloaded";
class PartnersSlider {
    constructor($el) {
        this.$el = $el;

        this.options = {
            // autoPlay: true,
            pageDots: true,
            wrapAround: true,
            prevNextButtons: false,
            freeScroll: true,
            cellSelector: '.partners-slider__slide',
            cellAlign: 'center'
        };

        if(this.$el.length) {
            this._init();
        }
    }

    _init() {
        this.$slides = this.$el.find('.partners-slider__slide');
        this.slidesCount = this.$slides.length;

        if(this.slidesCount > 0) {
            this._createSlider();
        }
    }

    _createSlider() {
        new Flickity(this.$el[0], this.options);
    }
}
export default PartnersSlider;
